/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PreferencesInputDto } from './PreferencesInputDto';

export type GetSolutionsDto = {
  item_type: GetSolutionsDto.item_type;
  employee_id: string;
  preferences?: PreferencesInputDto;
  favorite_carriers?: Array<string>;
};
export namespace GetSolutionsDto {
  export enum item_type {
    MEDICAL_PLAN = 'MEDICAL_PLAN',
    HSA = 'HSA',
    VISION = 'VISION',
    DENTAL = 'DENTAL',
  }
}
